var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0835 0L13 3.08331L16.6669 6.74996L19.667 3.66664L16.0835 0ZM16.6669 4.99997L14.7501 3.08331L16.0835 1.74999L18.0002 3.66664L16.6669 4.99997ZM5.58448 16.0834L3.66775 14.1667L12.5847 5.5826L11.7513 4.66593L1.9177 14.1667L0.000976562 20L5.66781 17.75L15.4181 8.33341L14.5847 7.41675L5.58448 16.0834ZM2.91773 15.0834L4.66779 16.8334L2.00103 17.9167L2.91773 15.0834Z",
    fill: "#006EBB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.adf581600ab675bf05e775c9e6f5f1dc.svg";
export { ForwardRef as ReactComponent };